import React from 'react';
import BaseLayout from 'layouts/BaseLayout';
import Head from 'next/head';
import Header from 'components/MedicalPosters/Header';
import MainContent from 'components/MedicalPosters/MainContent/index';

export default function MedicalPosters() {
  return (
    <BaseLayout hero={<Header />} hasPadding={false}>
      <Head>
        <title>Create professional medical & biology posters | Mind the Graph</title>

        <meta
          key="og:description"
          name="Create informative medical and biology posters in minutes. Access 40 000 scientific illustrations from 80+ fields. Sign up to Mindthegraph for free."
        />
        <meta
          name="keywords"
          content="Biology posters, medical posters, medical illustrations, biology illustrations"
        />
      </Head>

      <MainContent />
    </BaseLayout>
  );
}
